// Four deliberate cuts: three shuffled detail views, then the logo's front face.
export function createLogoIntroShots(random = Math.random) {
  const angles = [[-.78,.2,.72],[.72,.3,.62],[-.3,.68,.78],[.8,-.14,.7],[-.62,-.12,.72]];
  for (let i=angles.length-1;i>0;i--) {
    const j=Math.floor(random()*(i+1)); [angles[i],angles[j]]=[angles[j],angles[i]];
  }
  return [...angles.slice(0,3),[0,0,1]];
}
export const LOGO_INTRO_SHOT_MS = 600;
export const LOGO_INTRO_PULLBACK_MS = 2200;
export const LOGO_INTRO_DURATION = 3*LOGO_INTRO_SHOT_MS+LOGO_INTRO_PULLBACK_MS;
export const LOGO_INTRO_REPEAT_DURATION = LOGO_INTRO_DURATION;
const VISIT_KEY = 'codex-hero-visited-v1';
function getVisitStorage() {
  try { return typeof window !== 'undefined' ? window.localStorage : null; }
  catch { return null; }
}
export function hasCompletedLogoIntro(storage = getVisitStorage()) {
  try { return storage?.getItem(VISIT_KEY) === '1'; }
  catch { return false; }
}
export function markLogoIntroComplete(storage = getVisitStorage()) {
  try {
    if (!storage) return false;
    storage.setItem(VISIT_KEY, '1');
    return true;
  } catch { return false; }
}
export function logoIntroPhase(elapsed, {repeatVisit = false} = {}) {
  const time = Math.max(0, elapsed);
  // Every visit plays the same four shots, including returning visitors.
  const shot=Math.min(3,Math.floor(time/LOGO_INTRO_SHOT_MS));
  const pullbackMs=repeatVisit ? LOGO_INTRO_REPEAT_DURATION-3*LOGO_INTRO_SHOT_MS : LOGO_INTRO_PULLBACK_MS;
  const pullbackStart=3*LOGO_INTRO_SHOT_MS;
  // Start moving immediately on the fourth cut; ease only the arrival at hero.
  const pull=Math.max(0,Math.min(1,(time-pullbackStart)/pullbackMs));
  return {shot, drift:shot===3 ? 1 : Math.min(1,(time-shot*LOGO_INTRO_SHOT_MS)/LOGO_INTRO_SHOT_MS),
    pull:1-Math.pow(1-pull,3), done:time>=pullbackStart+pullbackMs};
}
